export const isZoneRu = /(localhost|\.(ru|dev-el|ads-dev-xs))$/.test(window.location.hostname);
